var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.location))]),(!_vm.isLoading)?_c('div',[_c('BasicTableComponent',{attrs:{"list":_vm.store.subtotals(_vm.location),"tableClass":"table2excel","tableID":`${_vm.location}_Days`,"hideColumns":[ 'StartDateTime', 'EndDateTime', 'shiftsMediaTypes', 'shiftsMediaTypesCounts', 'shiftsJson', 'IDUsed'],"columnOrder":['day'],"formatters":{
        'day' : ['d', 'ddd MM/DD/YY'], 
        'Interac_#' :  ['n', '0,0'],
      },"titles":{

      },"totals":_vm.store.totals(_vm.location)}}),_c('BasicTableComponent',{attrs:{"list":_vm.table,"tableClass":"table2excel","tableID":`${_vm.location}_Shifts`,"hideColumns":[ 'shiftsMediaTypes', 'shiftsMediaTypesCounts', 'shiftsJson', 'IDUsed'],"columnOrder":['day'],"formatters":{
        'day' : ['d', 'ddd MM/DD/YY'], 
        'StartDateTime' : ['d', 'h:mm a'],
        'EndDateTime' : ['d', 'h:mm a'],
        'Interac_#' :  ['n', '0,0'],
        
      },"titles":{
        'StartDateTime' : 'Shift Start', 
        'EndDateTime' : 'Shift End', 
      },"totals":_vm.store.totals(_vm.location)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }